import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { MediaFileFragmentDoc } from '../../../../fragments/__generated__/file.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserFilesQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type GetUserFilesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, uuid: string, files: Array<{ __typename?: 'File', uuid: string, createdAt: number, id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null, owner?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username: string, email?: string | null } | null }> } };

export type UploadedFileFragment = { __typename?: 'File', uuid: string, createdAt: number, id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null, owner?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username: string, email?: string | null } | null };

export const UploadedFileFragmentDoc = gql`
    fragment UploadedFile on File {
  ...MediaFile
  uuid
  owner {
    id
    firstName
    lastName
    username
    email
  }
  createdAt
}
    ${MediaFileFragmentDoc}`;
export const GetUserFilesDocument = gql`
    query GetUserFiles($userId: ID!) {
  user(data: {userId: $userId}) {
    id
    uuid
    files {
      ...UploadedFile
    }
  }
}
    ${UploadedFileFragmentDoc}`;

/**
 * __useGetUserFilesQuery__
 *
 * To run a query within a React component, call `useGetUserFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFilesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserFilesQuery(baseOptions: Apollo.QueryHookOptions<GetUserFilesQuery, GetUserFilesQueryVariables> & ({ variables: GetUserFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFilesQuery, GetUserFilesQueryVariables>(GetUserFilesDocument, options);
      }
export function useGetUserFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFilesQuery, GetUserFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFilesQuery, GetUserFilesQueryVariables>(GetUserFilesDocument, options);
        }
// @ts-ignore
export function useGetUserFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserFilesQuery, GetUserFilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserFilesQuery, GetUserFilesQueryVariables>;
export function useGetUserFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserFilesQuery, GetUserFilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserFilesQuery | undefined, GetUserFilesQueryVariables>;
export function useGetUserFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserFilesQuery, GetUserFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserFilesQuery, GetUserFilesQueryVariables>(GetUserFilesDocument, options);
        }
export type GetUserFilesQueryHookResult = ReturnType<typeof useGetUserFilesQuery>;
export type GetUserFilesLazyQueryHookResult = ReturnType<typeof useGetUserFilesLazyQuery>;
export type GetUserFilesSuspenseQueryHookResult = ReturnType<typeof useGetUserFilesSuspenseQuery>;
export type GetUserFilesQueryResult = Apollo.QueryResult<GetUserFilesQuery, GetUserFilesQueryVariables>;